import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, input, Input, numberAttribute, OnDestroy, OnInit, Renderer2, signal, ViewChild } from '@angular/core';
import { RdGameService } from '../../services/games/rd-game';
import * as _ from "lodash";
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatRadioChange, MatRadioModule} from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { AllStatus } from '../../../core/services/status/all-status';
import { ConfigurationService } from '../../../core/services/configs/configuration';
import { RaitingSystem } from '../../services/ratings/raiting-system';
import { ITrainingAnswer, TrainingMode } from '../../services/trainings/training-mode';
import { Subscription, take } from 'rxjs';
import { DifficultyLevel } from '../../services/levels/difficulty-level';
import { TranslatePipe } from '@ngx-translate/core';
import { CardHictoryPlayer } from '../../services/history/card-hictory-player';
import { TeamEvent } from '../../services/teams/team-event';
import { QueryAi } from '../../services/ai/query-ai';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AiWindow } from '../dialogs/ai-window/ai-window';
import { ProgressPlayerService } from '../../../features/progress-player/progress-player.service';
import { LanguageService } from '../../../core/services/language/language.service';
import { Downtime } from '../../../core/services/times/downtime';
import { NotificationService } from '../../../core/services/Notification/notification';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { WorkCardService } from '../../services/work-card';
import { CardCounter } from '../card-counter/card-counter';
import { PlayFieldCircle } from '../fields/play-field-circle/play-field-circle';
import { ICard, ICardResultState, ICardUserVariant, ICardVariant } from '../../model/i-card';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-card-info',
  imports: [MatCheckboxModule, MatRadioModule, FormsModule, TranslatePipe,MatTooltipModule, CardCounter, PlayFieldCircle], 
  templateUrl: './card-info.html',
  styleUrl: './card-info.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardInfo implements OnInit, OnDestroy{
  @Input() player: any;
  @Input({transform: numberAttribute}) turning: number;
  playersLeng = input<any>();
  players = input<any>();
  userResponse = input<any>();

  rdUse = inject(RdGameService);
  progressService = inject(ProgressPlayerService);
  levelSer = inject(DifficultyLevel);
  language = inject(LanguageService)
  subTrainingMode: Subscription;
  public allStatus$ = inject(AllStatus);
  configuration = inject(ConfigurationService);
  raiting = inject(RaitingSystem);
  trainingModeSevvice = inject(TrainingMode);
  cardHictory = inject(CardHictoryPlayer);
  teamEvent = inject(TeamEvent);
  readonly dialog = inject(MatDialog);
  ai = inject(QueryAi);
  private readonly destroyRef = inject(DestroyRef);
  downtime = inject(Downtime);
  cardInfo = inject(WorkCardService);

  playerResultState: ICardResultState | null = null;

  get isEmptyPlayerScore(): boolean {
    return this.playerResultState === 'missed-correct-answer';
  }

  get isNonPositivePlayerScore(): boolean {
    return this.playerResultState === 'non-positive-score';
  }
   

  subCart: Subscription;
  subOtherCards: Subscription;
  showCard: any = {};
  listCards: any = [];
  private listTxt: any = [];
  lodash = _;
  trainingMode: number = 0;
  
  indexCards:number = 0;
  
  showGroupButton: boolean = true;
  isActiveUser: boolean = false;
  isOtherCards: boolean = false;

  isCollapseExpand = signal<boolean>(true);
  list: ITrainingAnswer[] = [];
  selectVariant: number;
  myResult: number|null = null;
  notification = inject(NotificationService);

  private tooltipElement: HTMLElement | null = null;
  private renderer = inject(Renderer2);
  
  private listPrefix: any = [];
 
  @ViewChild('tooltip') tooltip: MatTooltip;
  tooltipMessage:string = '';
  isShowExplanation: boolean = false;

  constructor( private ref: ChangeDetectorRef){
    this.listTxt["ru"] = ["Вы обрабатываете "," из "," карточек"," карточки"];
    this.listTxt["uk"] = ["Ви обробляєте "," з "," карток"," карток"];
    this.listTxt["en"] = ["Working on "," out of "," cards"," cards"];
  }

  onMouseOver(event: MouseEvent){
   // this.tooltipMessage = '';
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      this.tooltipElement = this.renderer.createElement('span');
      this.tooltipMessage = targetElement.outerText;
      // @ts-ignore
      this.tooltipElement.innerText = `${this.listPrefix[this.language.appLanguage as string][0]}"${targetElement.innerText}"${this.listPrefix[this.language.appLanguage as string][1]}`;
      this.tooltipElement?.classList.add('another-tooltip');

      targetElement.appendChild(this.tooltipElement as HTMLElement);

      this.ref.detectChanges();
     
    }
    
  }

  onMouseOut(event: MouseEvent){
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      targetElement.removeChild(this.tooltipElement as HTMLElement);
      this.tooltipElement = null;
      //this.qq$.hideTooltip();
      this.tooltipMessage = '';
      // this.tooltipMessage.set(`${this.listPrefix[this.language.appLanguage as string][0]}"${targetElement.innerText}"${this.listPrefix[this.language.appLanguage as string][1]}`);
      // this.tooltip.hide();
      this.ref.detectChanges();
     
    }
  }


  ngOnInit(){
    this.isShowExplanation = false;
    this.listPrefix["ru"] = ["Узнать значения слова "," у чата GPT"];
    this.listPrefix["uk"] = ["Дізнатися значення слова "," у чату GPT"];
    this.listPrefix["en"] = ["Find out the meaning of the word "," at the GPT chat"];
    this.list = [];
    this.allStatus$.txtCardInfo = '';
    let isAddCard:boolean = true;
    this.cardHictory.clearHistory();
    // if(this.playersLeng() === 1){
    //   this.cardHictory.initForOne();
    // }
    // TODO ось тут потрібно внедряти перемикача
    this.rdUse.getCards();
    this.subCart = this.rdUse.cards$.subscribe((cards: any)=>{
      
      if(this.turning === this.player.player_id && this.allStatus$.isRollDice){
        if(this.allStatus$.explanationTxt()){
          this.clearExplanation();
          this.isCollapseExpand.set(true);
        }
      }
      if(cards){
        this.tooltipMessage = '';
        if(this.turning === this.player.player_id){
          //this.allStatus$.setViewBlockDice(false);
          this.isCollapseExpand.set(true);
          isAddCard = this.workingWithCard(cards, isAddCard);
        }else if(this.turning !== this.player.player_id){
          //TODO тут проблема
          this.cardInfo.getCard(cards.card_id).pipe(
            take(1)
          ).subscribe((res:any)=>{
            isAddCard = this.workingWithCard(res.card, isAddCard);
            this.allStatus$.setViewBlockDice(false);
            this.ref.markForCheck();
          });
        }

      }else{
        this.allStatus$.isNewListVariant = true;
        this.allStatus$.setViewBlockDice(true);
        this.showCard = {};
        this.isActiveUser = false;
        this.resetPlayerResult();
        isAddCard = true;
      }
      this.ref.markForCheck();
    });

    this.subTrainingMode = this.allStatus$.trainingMode$.subscribe((value: number) =>{
      this.trainingMode = value; 
    });
    this.rdUse.getOtherCards();
    this.subOtherCards = this.rdUse.otherCards$.subscribe((listCards:any) => {
      if(listCards){
        this.listCards = listCards;
      }else{
        this.listCards = [];
      }
      
    });
  }

  playersName(): string{
   let name = '';
   
    this.players().forEach((player: any) => {
      if(this.turning === player.player_id){
        name = player.name;
      }
    });
    return name;
  }

  workingWithCard(cards: any, isAddCard: boolean){
    if(!this.isOtherCards){
      const isNewCard = this.showCard?.card_id !== cards?.card_id ||
        this.showCard?.turn_id !== cards?.turn_id;
      if(isNewCard){
        this.resetPlayerResult();
      }
      if(isAddCard){
        this.cardHictory.addCardHistory({name: cards.name, level: cards.level, card_id : cards.card_id, type_id: cards.type_id});
        isAddCard = false;
      }
      this.allStatus$.setViewBlockDice(false);
      this.showCard = cards;
      if(this.showCard?.data?.variants){

        this.getList(this.showCard?.data.variants);
      }
      if(this.turning === this.player.player_id){
        this.isActiveUser = true;
        if(!this.allStatus$.isPassBoll){
          this.showGroupButton = true;
          this.countCards();
        }
      }
      if(this.turning !== this.player.player_id && this.playersLeng() > 1){
        this.allStatus$.isPassBoll = false;
        this.allStatus$.isRollDice = true;
        this.allStatus$.isNewListVariant = true;
        this.allStatus$.txtCardInfo = '';
      }
    }
    return isAddCard;
  }

  ngOnDestroy(): void {
    this.allStatus$.isNewListVariant = true;
    if(this.subCart){
      this.subCart.unsubscribe();
    }
    if(this.subTrainingMode){
      this.subTrainingMode.unsubscribe();
    }
    if(this.subOtherCards){
      this.subOtherCards.unsubscribe();
    }
    
    this.progressService.clearAll();
  }

  countCards(){
    const allCard = 1 + this.listCards.length;
    const val = 1 + this.indexCards;
    const txt = (this.listCards.length) ? `${this.listTxt[this.language.appLanguage as string][0]}${val}${this.listTxt[this.language.appLanguage as string][1]}${allCard}${this.listTxt[this.language.appLanguage as string][2]}`: `${this.listTxt[this.language.appLanguage as string][0]}${val}${this.listTxt[this.language.appLanguage as string][1]}${allCard}${this.listTxt[this.language.appLanguage as string][3]}`;
    this.allStatus$.txtCardInfo = txt;
  }

  fnRunInitOtherCards(){
    if(this.listCards.length > this.indexCards){
      
      let cards = this.listCards[this.indexCards];
      //this.cardHictory.addCardHistory({name: cards.name, level: cards.level, card_id : cards.card_id, type_id: cards.type_id});
      this.cardInfo.getCard(cards.card_id).pipe(
        take(1)
      ).subscribe((res:any)=>{
        // isAddCard = this.workingWithCard(res.card, isAddCard);

        this.resetPlayerResult();
        this.showCard = res.card;
        this.allStatus$.isNewListVariant = true;
        if(this.showCard?.data?.variants){
          this.getList(this.showCard?.data.variants);
        }
        if(this.turning === this.player.player_id){
          this.isActiveUser = true;
          if(!this.allStatus$.isPassBoll){
            this.showGroupButton = true;
          }
        }
        this.indexCards = this.indexCards + 1;
        this.countCards();

        this.ref.markForCheck();
      });
    }else{
      this.isOtherCards = false;
      this.allStatus$.isPassBoll = true;
      this.indexCards = 0;
    }
    
  }

  private getList(variants: ICardVariant[]): void {
    if(this.allStatus$.isNewListVariant){
      this.resetPlayerResult();
      if(this.turning === this.player.player_id){
        if(this.showCard?.level){
          this.levelSer.isNewLevel(this.showCard?.level, this.showCard?.type_id, this.player.player_id);
        }
      }
      this.list = [];
      this.allStatus$.maxPointresultCard = 0;
      variants.forEach((item: ICardVariant, index: number)=>{
        if(this.configuration.configuration.config.show_points){
          this.list.push({...item, variant_name: `${item.variant_name}`,variant: false ,index, });
        }else{
          this.list.push({...item,variant: false ,index});
        }
        if(item.v_points > 0){
          this.allStatus$.maxPointresultCard = this.allStatus$.maxPointresultCard + item.v_points;
        }
      });
      //this.allStatus$.isNewListVariant = false;
      if(this.playersLeng() === 1){
        this.isCollapseExpand.set(true);
      }
     
    }
    
  }

  update(variant: boolean, index?: number): void {
    this.list.forEach((item: ITrainingAnswer)=>{
      if(item.index === index){
        item.variant = variant;
      }
    })
  }

  private resetPlayerResult(): void {
    this.playerResultState = null;
    this.myResult = null;
  }

  private calculateResultPercentage(points: number, maxPoints: number): number {
    if(maxPoints <= 0){
      return 0;
    }

    return Number(((points / maxPoints) * 100).toFixed(2));
  }

  onRadioGroupChange(event: MatRadioChange) {
    this.list.forEach((item: ITrainingAnswer)=>{
        item.variant = false;
      if(typeof event.value === 'number' && item.index === event.value){
        item.variant = true;
      }
    });
    }

  asseccCard(){
    if(this.showCard?.data?.variants){  
      this.allStatus$.isNewListVariant = false;        
      let otherCard: ICard = structuredClone(this.showCard);
      otherCard.data.userList = this.list;
      
      if(otherCard.level){
        this.levelSer.initWork(otherCard);
      }

      let result = this.raiting.successesInGame(otherCard);


      this.myResult = this.calculateResultPercentage(result.points, result.maxPoints);

      if(!this.configuration.configuration?.config?.is_demo){
        this.progressService.fnSetRating(otherCard.type_id, result.points, result.maxPoints, otherCard?.level);
      }

      if(this.trainingMode){
        if( (this.playersLeng() as number) > 1 ){
          this.showGroupButton = false;
        }else{
          this.isShowExplanation = true;
        }
        
        this.list = this.trainingModeSevvice.checkingCorrectnessAnswer(result.maxPoints, this.showCard?.data?.variants_type, this.list);
        if((this.playersLeng() as number) > 1 && otherCard.data?.explanation){
          this.allStatus$.setExplanationData({cardId: otherCard.card_id,count: this.cardHictory.countReverse(otherCard.type_id, otherCard.level ), level: otherCard.level}); // this.cardHictory.countCardLevel(otherCard.type_id, otherCard.level )
          this.allStatus$.setExplanationTxt(otherCard.data.explanation);
        }
      }
      this.allStatus$.setNowCard(otherCard);

      //TODO other_true && team event
      if( (this.playersLeng() as number) > 1 ){
        this.teamEvent.fn(this.showCard, this.player.player_id, result.points, this.playersLeng());
      }
    }
    this.downtime.refreshTimer();
    
    if(this.listCards.length){
      this.isOtherCards = true;
      this.fnRunInitOtherCards();
    }else{

      if( (this.playersLeng() as number) > 1 ){
        this.showGroupButton = false;
        this.allStatus$.isPassBoll = true;
      }else{
        this.isShowExplanation = true;
      }
      //this.allStatus$.maxPointresultCard = 0;
      
    }

  }

  fnIsShowExplanation(){
    this.allStatus$.isPassBoll = true;
    this.showGroupButton = false;
    this.isShowExplanation = false;
  }

  clearExplanation(){
    this.allStatus$.clearExplanationTxt();
  }

  fnClickElement(event: Event){
    event.stopPropagation();
    const targetElement: HTMLElement = event.target as HTMLElement;
    if(targetElement.tagName === 'EM'){
      this.allStatus$.setDisplayProgressSpinner(true);
      let txtForSearch = this.tooltipMessage;
      this.ai.getWikiInfo(txtForSearch).pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef)
      ).subscribe({
        next:(result)=>{
          this.allStatus$.setDisplayProgressSpinner(false);
          if(result.success){ 
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = 'nutri-templs';
            dialogConfig.backdropClass = 'nutri-templs-backdrop';
            dialogConfig.data = {
              text: result.data
            }
            const dialogRef = this.dialog.open(AiWindow, dialogConfig);
          }else{
            
            this.notification.setMessage(result.message);
            this.notification.display();
            this.allStatus$.setDisplayProgressSpinner(false);
          }
        },
        error: (err: any)=>{
         
          this.notification.setMessage(err);
          this.notification.display();
          this.allStatus$.setDisplayProgressSpinner(false);
        }
    });
     
    }
  }

  collapseExpand(){
    this.isCollapseExpand.set(!this.isCollapseExpand());
  }
  
}
